export const CHANNEL_711 = '7-11'

export const CHANNEL_FAMILY = 'fmt'

export const CHANNEL_711_CROSS = '7-11-cross'

export const CHANNEL_CAT = 'cat'

/** 全家冷链 */
export const CHANNEL_FAMILY_COLD = 'fmt_cold'

/**服务商是flash */
export const FLASH = 'FLASH'
